// Lightweight dev-only logger that tree-shakes in production builds.
// Vite replaces import.meta.env.DEV with a boolean at build time.
export function devLog(...args: unknown[]): void {
  // Ensure this condition is statically analyzable for dead-code elimination.
  if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

